/**
 * DatePicker Component - Component Definition
 * ===========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { DatePickerController } from './controller';
import { DATE_PICKER_TEMPLATE } from './template';
import { WEEKDAYS, MONTHS, MONTHS_SHORT, SIZES, BASE_CLASSES, ICONS, DEFAULTS, DatePickerSize } from './constants';

export interface IDatePickerComponentBindings {
  label?: string;
  ariaLabel?: string;
  placeholder?: string;
  helpMessage?: string;
  error?: boolean;
  disabled?: boolean;
  size?: DatePickerSize;
  onChange?: (args: { value: string; date: Date | null }) => void;
}

export const datePickerComponentDefinition: IComponentOptions = {
  template: DATE_PICKER_TEMPLATE,
  controller: DatePickerController,
  require: { ngModelCtrl: '?ngModel' },
  // Slots nombrados: <ec-label>/<ec-help> dentro del componente.
  transclude: { labelSlot: '?ecLabel', helpSlot: '?ecHelp' },
  bindings: {
    label: '@',
    ariaLabel: '@',
    placeholder: '@',
    helpMessage: '@',
    error: '<',
    disabled: '<',
    size: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.datePicker';

const datePickerModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecDatePicker', datePickerComponentDefinition);

export { DatePickerController, DATE_PICKER_TEMPLATE, WEEKDAYS, MONTHS, MONTHS_SHORT, SIZES, BASE_CLASSES, ICONS, DEFAULTS };
export type { DatePickerSize } from './constants';
export default datePickerModule;
